<template>
  <div class="wrapper">
    <p class="title">{{ title }}</p>

    <slot />
  </div>
</template>

<script>
export default {
  name: 'RadioWrapper',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
$input-color:                 #262626;

.wrapper {
  background: $input-color;
  border-radius: 10px;
  padding: 16px;

  .title {
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    color: #FFFFFF;
    padding-bottom: 8px;
  }
}
</style>
